import { axiosClient } from '../axiosClient';
import type { AppError, AffectedDevice } from '@/types/error.types';

interface GetErrorsParams {
  status?: string;
  severity?: string;
  dateRange?: {
    start: string;
    end: string;
  };
  page?: number;
  limit?: number;
}

interface GetErrorsResponse {
  errors: AppError[];
  total: number;
  page: number;
  limit: number;
}

export const getErrors = async (params?: GetErrorsParams): Promise<GetErrorsResponse> => {
  try {
    const response = await axiosClient.get('/errors', { params });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch errors:', error);
    throw error;
  }
};

export const getErrorById = async (id: string): Promise<AppError> => {
  try {
    const response = await axiosClient.get(`/errors/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch error ${id}:`, error);
    throw error;
  }
};

export const resolveError = async (id: string, notes?: string): Promise<void> => {
  try {
    await axiosClient.patch(`/errors/${id}/resolve`, { notes });
  } catch (error) {
    console.error(`Failed to resolve error ${id}:`, error);
    throw error;
  }
};

export const getErrorsByType = async () => {
  try {
    const response = await axiosClient.get('/dashboard/errors-by-type');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch errors by type:', error);
    throw error;
  }
};

export const getAffectedDevices = async (errorId: string): Promise<AffectedDevice[]> => {
  try {
    const response = await axiosClient.get(`/errors/${errorId}/affected-devices`);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch affected devices for error ${errorId}:`, error);
    throw error;
  }
};
